// @ts-strict-ignore
import { Vector3 } from 'three';

export class WxShape {
  public closed: boolean;

  public getPoints(isConnection?: boolean): Vector3[] {
    return [];
  }
}
